export const SCSS_COLORS = 
{
  "$white": "#fff",
  "$black-copy": "#000",
  "$black": "#000",
  "$dark-copy": "#404040",
  "$light-copy": "#808080",
  "$oe-blue": "#0080ff",
  "$human-blue": "#4fa3d9",
  "$oe-blue-medium": "#cce5ff",
  "$oe-blue-10": "rgba(0,128,255,0.1)",
  "$oe-blue-hover": "#0060bf",
  "$blue-grey": "#899fb5",
  "$bg-blue-grey": "#a6d4ff",
  "$bg-light-blue": "#edf6ff",
  "$bg-dark-blue": "#ddeefe",
  "$bg-white": "#fff",
  "$bg-gray-blue": "#dde5ed",
  "$border-blue": "#cce3fb",
  "$border-gray": "#cad1d9",
  "$border-grey-light": "#ddd",
  "$border-grey-medium": "#e5e5e5",
  "$border-modal": "#dcdcdc",
  "$border-shadow": "rgba(0,0,0,0.1)",
  "$shadow-grey": "#9e9e9e",
  "$green": "#9fc32f",
  "$orange": "#ff6000",
  "$orange-active": "#f15d00",
  "$orange-inactive": "#e8b987",
  "$error-red": "#fb4a4a",
  "$red": "#f00",
  "$red-10": "rgba(255,0,0,0.1)",
  "$error-red-overlay": "#fee",
  "$success-green": "#28b473",
  "$success-light-green": "#01db8c",
  "$tile-blue": "#7cb7e4",
  "$tile-blue-overlay": "rgba(103,178,231,0.8)",
  "$oe-card-grey-shadow": "rgba(0,0,0,0.05)",
  "$oe-background-light-blue": "#edf5ff",
  "$oe-blue-titles": "#007efe",
  "$inactive-text-grey": "#d8d8d8",
  "$progress-blue": "#0085ff",
  "$progress-green": "#a0c13a",
  "$progress-pink": "#f228c1",
  "$progress-grey": "rgba(0,0,0,0.36)",
  "$inactive-light-grey": "#d8d8d8",
  "$oe-background-color": "#edf5ff",
  "$sub-section-background-grey": "#f4f3f4",
  "$certificate-background-grey": "#f1f1f1",
  "$light-label": "rgba(0,0,0,0.66)",
  "$light-shadow": "rgba(0,0,0,0.1)",
  "$darker-shadow": "rgba(0,0,0,0.23)",
  "$light-grey-separator": "#e4e4e4",
  "$light-grey-banner": "#efefef",
  "$certificate-blue-gradient-light": "#009cff",
  "$certificate-blue-gradient-dark": "#0084ff",
  "$certificate-blue-gradient-dark-10": "rgba(0,132,255,0.1)",
  "$certificate-blue-gradient-dark-5": "rgba(0,132,255,0.05)",
  "$badge-deep-blue": "#146cb2",
  "$badge-text-blue": "#0091ff",
  "$ivy-yellow": "#fffc00",
  "$pc-yellow": "#faeea2",
  "$aquamarine": "#00cad4",
  "$green-main": "#3c0",
  "$vibrant-green": "#bbf55c",
  "$lighter-vibrant-green": "#bcf85c",
  "$zoom-blue": "#2d8cff",
  "$background-light-grey": "#ebebeb",
  "$dark-grey": "#828282",
  "$card-text": "#6e6e6e",
  "$dark-grey-dark": "#222",
  "$dark-grey-medium": "#444",
  "$dark-grey-light": "#666",
  "$skeleton-grey": "#dcdcdc",
  "$light-grey-heavy": "#999",
  "$light-grey-medium": "#eee",
  "$light-grey-medium-background": "#ededed",
  "$light-grey-light": "#f0f0f0",
  "$light-grey-placeholder": "#f1f3f4",
  "$light-grey-background": "#d1d1d1",
  "$light-grey-p-background": "#f4f4f4",
  "$primary-aqua-blue": "#00dbd1",
  "$secondary-pacific-blue-dark": "#00005c",
  "$private-class-light-blue": "#0078ff",
  "$private-class-dark-blue": "#000073",
  "$pc-scroll-bar-light-blue": "#3393ff",
  "$pc-scroll-bar-dark-blue": "#0060cc",
  "$blue-medium-jr": "#ebf7ff",
  "$sunny-orange": "#f60",
  "$error": "#f41d1d",
  "$surface-primary-main-150": "#b3d7ff",
  "$surface-primary-main-25": "#f2f8ff"
}



// WEBPACK FOOTER //
// ./ts/colors.ts